import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ToggleField } from 'view/components/toggle'
import { Locale, Translation } from 'locale'
import { ToolbarToggleWrapper } from 'view/components/datagrid/toolbar/toolbarStyles'
import { GlobalGridSettings } from 'store/grid/gridTypes'
import { GridActions } from 'store/grid'
import { globalGridSettingsSelector } from 'selectors/globalGridSelectors'
import { KeysMatching } from 'utils'

interface GridSettingToggleSwitch {
  label: Translation
  setting: KeysMatching<GlobalGridSettings, boolean>
  globalGridSettings: GlobalGridSettings
  onSaveGlobalGridSettings: (globalGridSettings: Partial<GlobalGridSettings>) => unknown
}

const GridSettingsToggleSwitchComponent: React.FC<GridSettingToggleSwitch> = props => {
  const { globalGridSettings, onSaveGlobalGridSettings, setting, label } = props

  const handleSwitch = (checked: boolean) => {
    onSaveGlobalGridSettings({
      [setting]: checked
    })
  }

  return (
    <ToolbarToggleWrapper>
      <ToggleField label={Locale.translate(label)} checked={globalGridSettings[setting] ?? false} onUpdate={handleSwitch} />
    </ToolbarToggleWrapper>
  )
}

export const GridSettingToggleSwitch = connect(
  createStructuredSelector({
    globalGridSettings: globalGridSettingsSelector
  }),
  {
    onSaveGlobalGridSettings: GridActions.saveGlobalGridSettings
  }
)(GridSettingsToggleSwitchComponent)
